import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner
} from "reactstrap";
import { ArrowLeft, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { forgotPassword } from "../service/authApi"; 
import "../styles/ForgotPasswordPage.css";

const ForgotPasswordPage = () => {

    const [email, setEmail] = useState("");

    const [loading, setLoading] = useState(false);

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (!email.trim()) {

            toast.error("Email is required");

            return;
        }

        try {

            setLoading(true);

            const response =
                await forgotPassword(email);

            toast.success(response);

            setEmail("");

        }
        catch (error: any) {

            toast.error(
                error.response?.data?.message ||
                "Unable to send reset link."
            );

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <div className="forgot-page">

            <Container>

                <Row className="justify-content-center align-items-center min-vh-92">

                    <Col xl="5" lg="6" md="8" sm="10" xs="12">

                        <Card className="forgot-card shadow-lg border-0">

                            <CardBody className="p-5">

                               <div className="text-center mb-4">

    <div className="forgot-icon">
        <Mail size={34} />
    </div>

    <h2 className="page-title">
        Forgot Password?
    </h2>

    <p className="page-subtitle">
        Don't worry! Enter your registered email address and we'll send you a secure password reset link.
    </p>

</div>

                                <Form onSubmit={handleSubmit}>

                                    <FormGroup>

                                        <Label>

                                            Email Address

                                        </Label>

                                        <Input

                                            type="email"

                                            placeholder="Enter your email"

                                            value={email}

                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }

                                        />

                                    </FormGroup>

                                    <Button

                                        color="primary"

                                        className="w-100 mt-3 forgot-btn"

                                        disabled={loading}

                                    >
{
        loading ? (
            <>
                <Spinner
                    size="sm"
                    className="me-2"
                />
                Sending...
            </>
        ) : (
            "Send Reset Link"
        )
    }

                                    </Button>

                                </Form>

                                <div className="text-center mt-4">

                                    <Link
                                        to="/login"
                                        className="back-login"
                                    >

                                        <ArrowLeft size={18} />

                                        Back to Login

                                    </Link>

                                </div>

                            </CardBody>

                        </Card>

                    </Col>

                </Row>

            </Container>

        </div>

    );

};

export default ForgotPasswordPage;